import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { EnvironmentsService } from '@references/shared/services/environments.service';

@Injectable()
export class BrandedTitleStrategy extends TitleStrategy {
  constructor(
    private readonly _title: Title,
    private readonly _translate: TranslateService,
    private readonly _environments: EnvironmentsService
  ) {
    super();
  }

  public override updateTitle(snapshot: RouterStateSnapshot): void {
    const key = this.buildTitle(snapshot);
    const brand = this._environments.brandName;

    if (!key) {
      this._title.setTitle(`${brand} - References checked`);
      return;
    }

    this._translate.get(key).subscribe((translated: string) => {
      this._title.setTitle(`${translated} – ${brand}`);
    });
  }
}
